import { Route, Routes } from "react-router-dom";
// import TopBar from "../Screen/User/TopBar/TopBar";
import NavBar from "../Screen/User/NavBar/NavBar";
import Footer from "../Screen/User/Footer/Footer";

// Screens
import Wallet from "../Screen/User/Wallet/Wallet";
import TransactionHistory from "../Screen/User/NavBar/Wallet/TransactionHistory/TransactionHistory";

import Home from "../Screen/User/Home/Home";
import Super from "../Screen/User/Super/Super";
import Master from "../Screen/User/Master/Master";
import User from "../Screen/User/User/User";
import Broker from "../Screen/User/Broker/Broker";
import Watchlist from "../Screen/User/Watchlist/Watchlist";
import WatchlistUser from "../Screen/User/WatchlistUser/Watchlist";

import Standing from "../Screen/User/Standing/Standing/Standing";
import ParkingWise from "../Screen/User/Standing/ParkingWise/ParkingWise";
import TradeWise from "../Screen/User/Standing/TradeWise/TradeWise";
import UserWise from "../Screen/User/Standing/UserWise/UserWise";
import MasterWise from "../Screen/User/Standing/MasterWise/MasterWise";
import SuperWise from "../Screen/User/Standing/SuperWise/SuperWise";

import Trade from "../Screen/User/Trade/Trade";
import Pending from "../Screen/User/Pending/Pending";
import Holding from "../Screen/User/Holding/Holding";

import SettlementAdmin from "../Screen/User/NavBar/Settlement/SettlementAdmin/Settlement";
import SettlementSuper from "../Screen/User/NavBar/Settlement/SettlementSuper/Settlement";
import SettlementMaster from "../Screen/User/NavBar/Settlement/SettlementMaster/Settlement";
import SettlementUser from "../Screen/User/NavBar/Settlement/SettlementUser/Settlement";

import Ledger from "../Screen/User/NavBar/Ledger/Ledger";
import SymbolQty from "../Screen/User/NavBar/SymbolQty/SymbolQty";
import SymbolLogs from "../Screen/User/NavBar/SymbolRejection/SymbolRejection";
import LoginLogs from "../Screen/User/NavBar/LoginHistory/LoginHistory";
import Rules from "../Screen/User/NavBar/Rules/Rules";
import ChangePassword from "../Screen/User/NavBar/ChangePassword/ChangePassword";
import Message from "../Screen/User/NavBar/Message/Message";
import Profile from "../Screen/User/NavBar/Profile/Profile";
import InterestBill from "../Screen/User/NavBar/InterestBill/InterestBill";
import GenerateBill from "../Screen/User/NavBar/GenerateBill/GenerateBill";
import GenerateBillAll from "../Screen/User/NavBar/GenerateBillAll/GenerateBill";
import Symbol from "../Screen/User/Symbol/Symbol";

import EditBroker from "../Screen/User/Broker/EditBroker/EditBroker";
import EditUser from "../Screen/User/User/EditUser/EditUser";
import EditMaster from "../Screen/User/Master/EditMaster/EditMaster";
import EditSuper from "../Screen/User/Super/EditSuper/EditSuper";

import useSize from "../Utils/useSize/useSize";
import { memo } from "react";

function Users() {
  const windowSize = useSize();
  const userType = Number(localStorage.getItem("user_type") || 7);

  const isAdmin = userType === 1;
  const isSuper = userType === 2;
  const isMaster = userType === 3;
  const isBroker = userType === 5;
  const isSubBroker = userType === 5;
  const isUser = userType === 4;

  return (
    <div style={{ height: windowSize[1] }}>
      <NavBar />

      <div style={{ height: windowSize[1] - 100, overflowY: "auto" }}>
        <Routes>
          <Route index element={isUser ? <WatchlistUser /> : <Home />} />
          <Route path="*" element={isUser ? <WatchlistUser /> : <Home />} />

          <Route
            path="/Watchlist"
            element={isUser ? <WatchlistUser /> : <Watchlist />}
          />

          {isAdmin && <Route path="/Super" element={<Super />} />}
          {(isAdmin || isSuper) && (
            <Route path="/Master" element={<Master />} />
          )}
          {(isAdmin || isSuper || isMaster || isBroker) && (
            <Route path="/User" element={<User />} />
          )}
          {(isAdmin || isSuper || isMaster || isBroker) && (
            <Route path="/Wallet" element={<Wallet />} />
          )}

          {isUser && (
            <Route
              path="/TransactionHistory"
              element={<TransactionHistory />}
            />
          )}

          {(isAdmin || isSuper || isMaster) && (
            <Route path="/Broker" element={<Broker />} />
          )}

          <Route path="/Standing" element={<Standing />} />

          {isAdmin && (
            <Route path="/StandingSuperWise" element={<SuperWise />} />
          )}
          {(isAdmin || isSuper) && (
            <Route path="/StandingMasterWise" element={<MasterWise />} />
          )}
          {(isAdmin || isSuper || isMaster) && (
            <Route path="/StandingUserWise" element={<UserWise />} />
          )}

          {(isAdmin || isSuper || isMaster || isBroker || isSubBroker) && (
            <>
              <Route path="/StandingParkingWise" element={<ParkingWise />} />
              <Route path="/StandingTradeWise" element={<TradeWise />} />
            </>
          )}

          <Route path="/Trade" element={<Trade />} />
          <Route path="/Pending" element={<Pending />} />

          {(isAdmin || isSuper || isMaster || isBroker || isSubBroker) && (
            <Route path="/Holding" element={<Holding />} />
          )}

          {isAdmin && (
            <Route path="/SettlementAdmin" element={<SettlementAdmin />} />
          )}
          {(isAdmin || isSuper) && (
            <Route path="/SettlementSuper" element={<SettlementSuper />} />
          )}
          {(isAdmin || isSuper || isMaster) && (
            <Route path="/SettlementMaster" element={<SettlementMaster />} />
          )}
          {isUser && (
            <Route path="/SettlementUser" element={<SettlementUser />} />
          )}

          <Route path="/ChangePassword" element={<ChangePassword />} />
          <Route path="/Ledger" element={<Ledger />} />
          <Route path="/LoginLogs" element={<LoginLogs />} />

          {isUser && <Route path="/SymbolLogs" element={<SymbolLogs />} />}

          <Route path="/SymbolQty" element={<SymbolQty />} />
          <Route path="/Rules" element={<Rules />} />
          <Route path="/Message" element={<Message />} />
          <Route path="/Profile" element={<Profile />} />
          <Route path="/InterestBill" element={<InterestBill />} />
          <Route path="/GenerateBill" element={<GenerateBill />} />
          {(isAdmin || isSuper || isMaster || isBroker) && (
            <Route path="/GenerateBillAll" element={<GenerateBillAll />} />
          )}

          <Route path="/Symbol" element={<Symbol />} />
        </Routes>
      </div>

      <Footer />

      {/* Modals */}
      <EditBroker />
      <EditUser />
      <EditMaster />
      <EditSuper />
    </div>
  );
}

export default memo(Users);
